import {SelectInterface} from "./Utils";

export const allCountries = (locale: string): SelectInterface[] => {
  const countries = require("i18n-iso-countries");
  countries.registerLocale(require(`i18n-iso-countries/langs/${locale}.json`));

  const countriesRaw = countries.getNames(locale, {select: "official"});

  return Object.entries(countriesRaw).map(([code, value]) => {
    return {value: code, label: value as string}
  }).sort((a, b) => a.label.localeCompare(b.label));
}
